import React from 'react';
import RadioGroupField from 'components/RadioGroupField';
import useOptions from '../../hooks/useOptions';

import './CommercialFreeholdField.styles.scss';
import './CommercialFreeholdField.styles.responsive.scss';

const CommercialFreeholdField: React.FC = () => {
  const { isTheCommercialFreeholdForSaleOptions } = useOptions();

  return (
    <div className="commercial-freehold-field">
      <RadioGroupField
        name="isTheCommercialFreeholdForSale"
        options={isTheCommercialFreeholdForSaleOptions}
        styled
      />
    </div>
  );
};

export default CommercialFreeholdField;
